var generateStyle = function generateStyle() {
  return {
    tableWrapper: {
      display: 'flex',
      flexBasis: '100%',
      flexDirection: 'column'
    }
  };
};
export default generateStyle;